<template>
  <container :class="['page-wrapper']">
    <deployment-checklist :class="['mb-8']" />
    <all-section-blocks :title="true" :tooltip="false" />
  </container>
</template>
<script>
export default {
  name: 'PagePublishing'
}
</script>



// WEBPACK FOOTER //
// src/pages/getting-started/publishing.vue